import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Button from '@nmx/template/dist/componentLibrary/components/Button';
// NM 2024 theme
import Nm2024Theme from '../../nm2024Theme/colors';

// eslint-disable-next-line import/prefer-default-export
export const ButtonNm2024 = styled(Button)`
  && {
    background-color: ${Nm2024Theme.cta.lightTheme};
    font-family: 'Source Sans', 'Helvetica Neue', Helvetica, sans-serif;
    font-weight: 600;
    border-radius: ${rem(30)};
    &:hover {
      background-color: ${Nm2024Theme.cta.lightThemeHover};
    }
    &:active {
      background-color: ${Nm2024Theme.cta.lightThemeActive};
    }
    &:disabled {
      background-color: ${Nm2024Theme.cta.darkThemeDisabled};
      border-color: ${Nm2024Theme.cta.darkThemeDisabled};
    }
  }
`;